export default {
    LOAD_USER_DATA: "LOAD_USER_DATA",
    HANDE_INPUT_CHANGE: "HANDE_INPUT_CHANGE",
    CLEAR_PHOTO: "CLEAR_PHOTO",
    UPLOAD_PHOTO: "UPLOAD_PHOTO",
  };
  